import { Component, } from '@angular/core';
import { CommunicationService } from './../../shared/services/communication.service';
import { Contentbox } from './../../models/contentboxes/contentboxes.model';

import { ApiService } from './../../shared/services/api.service';
import { ListBase } from './../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-contentboxes-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html' // TODO: tile list template
})
export class ContentboxesListComponent extends ListBase<Contentbox> {

  public url = 'contentboxes';
  public routePrefix = 'contentboxes';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }
}
